import { headerLine } from '@/modules/parts/headerLine.js';
import { updateHeaderWidthToSlide } from '@/modules/actions/updateHeaderWidthAction.js';

export const reelHeaderInitializing = (count, groupName = '') => {
  // PC表示時は渡されたgroupNameではなく、最新のグループ名を内部から取得
  if (!window.storeeelItems?.isMobile) {
    const groups = window.storeeelItems.contentGroups || [];
    const current = groups.find(g => g.id === window.iconId);
    if (current && current.name) {
      groupName = current.name;
    }
  }
  const reelHeader = document.querySelector('.storeeel-header');
  if (reelHeader) {
    reelHeader.remove();
  }
  const headerLineHTML = headerLine(count, groupName);
  const reelModal = document.querySelector('.storeeel-modal');
  const groupWrapper = document.querySelector('.storeeel-swiper-group-wrapper');

  if (reelModal) {
    if (window.storeeelItems?.isMobile) {
      reelModal.insertAdjacentHTML('afterbegin', headerLineHTML);
    } else if (groupWrapper) {
      groupWrapper.insertAdjacentHTML('afterbegin', headerLineHTML);
    }
  }
  const banners = document.querySelectorAll('.storeeel-movie-select_banner');
  banners.forEach((banner) => {
    banner.style.padding = '1px';
  });
  if (banners[window.moviePosition]) {
    banners[window.moviePosition].style.padding = '2px';
  }
  updateHeaderWidthToSlide();
};
